import { type ChartData } from './chartConfigUtils';
import CurrencyValueChart from './CurrencyValueChart';

interface PaidCommissionValueChartProps {
    readonly data: readonly ChartData[];
    readonly loading?: boolean;
    readonly referenceValue?: number;
    readonly currency?: 'EUR' | 'LEI';
}
function PaidCommissionValueChart({
    data,
    loading = false,
    referenceValue,
    currency,
}: PaidCommissionValueChartProps): JSX.Element {
    return (
        <CurrencyValueChart
            data={data}
            loading={loading}
            referenceValue={referenceValue}
            currency={currency}
            config={{
                chartType: 'column',
                yAxisTitleKeyEur: 'statistics.charts.paidCommissionValueEur',
                yAxisTitleKeyLei: 'statistics.charts.paidCommissionValueLei',
                yAxisTitleFallbackEur: 'Paid Interest Value (EUR)',
                yAxisTitleFallbackLei: 'Paid Interest Value (Lei)',
                color: '#722ed1',
                seriesNameKey: 'statistics.charts.paidCommissionValue',
                seriesNameFallback: 'Paid Interest Value',
            }}
        />
    );
}

export default PaidCommissionValueChart;
